import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { DrawerService } from '../../services/drawer.service';
import { InputDisplay, InputFieldType } from '@shared/ui/inputs';
import { ButtonSize, ButtonType } from '@shared/ui/buttons';
import { IconType } from '@shared/utils/icons';
import { PatternTypes } from '@shared/utils/patterns';
import { DrawerNames } from '../../models/drawer-names.models';

@Component({ template: '' })
export abstract class BaseDrawerComponent<TData = unknown> implements OnInit, OnDestroy {
  visible = false;
  data: TData | undefined;

  inputDisplay = InputDisplay;
  inputFieldType = InputFieldType;
  buttonType = ButtonType;
  buttonSize = ButtonSize;
  iconType = IconType;
  patternType = PatternTypes;

  protected abstract drawerId: DrawerNames;
  protected ngUnsubscribeBase$ = new Subject<void>();

  constructor(protected drawerService: DrawerService) {}

  ngOnInit(): void {
    this.drawerService.openDrawer$.pipe(takeUntil(this.ngUnsubscribeBase$)).subscribe((event) => {
      if (event.id === this.drawerId) {
        this.data = event.data as TData;
        this.visible = true;
        this.onOpen();
      }
    });

    this.drawerService.closeDrawer$.pipe(takeUntil(this.ngUnsubscribeBase$)).subscribe((drawerId) => {
      if (drawerId === this.drawerId) {
        this.closeDrawer();
      }
    });
  }

  closeDrawer(actionSucceeded: boolean = false): void {
    this.onClose();
    this.visible = false;
    if (actionSucceeded) {
      this.drawerService.close(this.drawerId);
    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribeBase$.next();
    this.ngUnsubscribeBase$.complete();
  }

  protected onOpen(): void {}
  protected onClose(): void {}
}
